import {useAuthenticationStatus} from "./AuthenticationStatusProvider";
import {useEffect} from "react";
import {apiRequest} from "../Utils/APIUtils";
import {useNavigate} from "react-router-dom";
import {useState} from "react";

// This component is used to protect a component from being accessed by unauthenticated users
// It checks the authentication status on mount and redirects the user to the redirect path (which defaults to '/login')
// if they are not authenticated.
// It also updates the global authentication status context
/*
    Use it like:
    <ProtectedComponent component={<ComponentThatShouldNotBeAccessedWithoutAuth />} />
 */
const ProtectedComponent = ({ component, redirectPath }) => {
    const [checkedStatus, setCheckedStatus] = useState(false);
    const navigate = useNavigate();
    const {setAuthenticationStatus} = useAuthenticationStatus();
    if (!redirectPath) {
        redirectPath = '/login';
    }

    useEffect(() => {
        apiRequest('auth/status')
            .then(data => {
                setCheckedStatus(true);
                setAuthenticationStatus({
                    isAuthenticated: data.isAuthenticated,
                    user: data.user,
                });
                if (!data.isAuthenticated) {
                    // If the user is not authenticated, send them to the redirect path
                    return navigate(redirectPath);
                }
            })
            .catch(error => {
                setCheckedStatus(true);
                setAuthenticationStatus({
                    isAuthenticated: false,
                    user: {},
                });
                console.error('Error checking authentication status:', error);
                return navigate(redirectPath);
                //TODO: Do we need to notify the user that there is a problem - they may be offline?
            });
    }, [navigate]); // Run once on component mount

    if (!checkedStatus) {
        return null;
    }
    return component;
}

export default ProtectedComponent;